(ns renolit-roofing-service.view.project-filters-popup
  (:require [clojure.string :as str]
            [dev.gethop.session.re-frame.cognito.token :as cognito.token]
            [re-frame.core :as rf]
            [renolit-roofing-service.layout.form :as layout.form]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.shared.domain.types :as dom.types]
            [renolit-roofing-service.tooltip :as tooltip]
            [renolit-roofing-service.tooltip.generic-popup :as tooltip.generic-popup]
            [renolit-roofing-service.util :as util]
            [renolit-roofing-service.util.localization :as util.localization]))

(def ^:const view-context ::product-filters-popup)

(def ^:const popup-id tooltip.generic-popup/default-popup-id)

(rf/reg-event-fx
 ::load-filters
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_]]
   {:http-xhrio
    {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
     :method :get
     :uri "/api/projects-filters"
     :response-format (util/ajax-transit-response-format)
     :on-success [::load-filters-success]
     :on-failure [::util/generic-error]}}))

(rf/reg-event-fx
 ::load-filters-success
 (fn [{:keys [db]} [_ resp]]
   (let [products (->> resp
                       :products
                       (keep-indexed (fn [i p]
                                       {:id (keyword (str i)) :name p}))
                       (into []))
         statuses (->> dom.types/service-status-pipeline
                       (mapv (fn [s]
                               {:id s :name (util.localization/dropdown-value :service-status s)})))
         filters {:products products
                  :statuses statuses}]
     {:db (assoc db
                 :projects-list/filters filters)})))

(rf/reg-sub
 ::filters
 (fn [db]
   (get db :projects-list/filters)))

(rf/reg-sub
 ::filters-by-key
 (fn [db [_ key]]
   (get-in db [:projects-list/filters key])))

(defn- get-filter-name-by-id
  [filters key id]
  (some #(when (= id (:id %)) (:name %)) (get-in filters [key :items])))

(rf/reg-sub
 ::applied-filters
 (fn [db]
   (get db :projects-list/applied-filters)))

(defn- applied-filters->query-params
  [{:keys [products statuses requires-review? aged-gt-10-years?]}]
  {:products (when (seq products) (str/join "," products))
   :statuses (when (seq statuses) (str/join "," (map name statuses)))
   :requires-review (when requires-review? "true")
   :aged-gt-10-years (when aged-gt-10-years? "true")})

(rf/reg-event-fx
 ::set-applied-filters
 (fn [{:keys [db]} [_ filters]]
   {:db (assoc db :projects-list/applied-filters filters)
    :fx [[:dispatch [::nav/add-query-params nil (applied-filters->query-params filters) :replace-route? true]]]}))

(defn form-submit
  [state on-submit]
  (let [input @state
        filters {:products (->> (get-in input [:products :selected])
                                (map #(get-filter-name-by-id input :products %))
                                (into #{}))
                 :statuses (->> (get-in input [:statuses :selected])
                                (into #{}))
                 :requires-review? (boolean (get-in input [:requires-review :selected]))
                 :aged-gt-10-years? (boolean (get-in input [:aged-gt-10-years :selected]))}]
    (rf/dispatch [::set-applied-filters filters])
    (rf/dispatch [::close])
    (on-submit)))

(defn- update-selected-items
  [state key item selected?]
  (swap! state
         (fn [s]
           (let [selected-path [key :selected]
                 current-selected-items (get-in s selected-path #{})
                 new-selected-items (if selected?
                                      (conj current-selected-items (:id item))
                                      (disj current-selected-items (:id item)))]
             (assoc-in s selected-path new-selected-items)))))

(defn- item-row
  [state key item]
  [:div.zones-dropdown__zone-partition
   [layout.form/item
    {:state state
     :type :checkbox
     :path [key :checked (:id item)]
     :schema [:boolean]
     :label (:name item)
     :on-change {:fn #(update-selected-items state key item (boolean %))}}]])

(defn my-complex-dropdown
  [{:keys [state key]}]
  (let [items @(rf/subscribe [::filters-by-key key])]
    [:div.zones-dropdown
     [:div.zones-dropdown__zone-partition-container
      (for [i items]
        ^{:key (:id i)}
        [item-row state key i])]]))

(defn- ids-selected-by-name
  [items names]
  (->> items
       (filter #(contains? names (:name %)))
       (map :id)
       (into #{})))

(defn- with-checked-from-selected
  [s key selected-ids]
  (-> s
      (assoc-in [key :selected] selected-ids)
      (assoc-in [key :checked] (into {} (map (fn [id] [id true]) selected-ids)))))

(defn main
  [{:keys [state on-submit]}]
  (let [filters @(rf/subscribe [::filters])
        applied-filters @(rf/subscribe [::applied-filters])]
    (when (and filters (not (get-in @state [:products :initialized?])))
      (swap! state (fn [s]
                     (-> s
                         (assoc-in [:products :items] (:products filters))
                         (assoc-in [:statuses :items] (:statuses filters))
                         (with-checked-from-selected :products (ids-selected-by-name (:products filters) (:products applied-filters #{})))
                         (with-checked-from-selected :statuses (:statuses applied-filters #{}))
                         (assoc-in [:products :initialized?] true)))))
    [:<>
     [tooltip.generic-popup/generic-popup-header
      {:title-transl-kw (t [:page.project.list/filters-title])
       :popup-id popup-id}]
     [:div.general-zone-revision-popup
      [layout.form/item
       {:context view-context
        :type :advanced-select
        :search? false
        :dropdown-component my-complex-dropdown
        :dropdown-props {:key :products}
        :path [:products :selected]
        :attribute-path [:products :items]
        :schema [:set :keyword]
        :multi? true
        :mandatory? true
        :read-only? true
        :state state
        :choice-id-kw :id
        :choice-display-name-kw :name
        :label-transl-kw :domain.project/product
        :placeholder-transl-kw :form.advanced-select/select}]
      [layout.form/item
       {:context view-context
        :type :advanced-select
        :search? false
        :dropdown-component my-complex-dropdown
        :dropdown-props {:key :statuses}
        :path [:statuses :selected]
        :attribute-path [:statuses :items]
        :schema [:set :keyword]
        :multi? true
        :mandatory? true
        :read-only? true
        :state state
        :choice-id-kw :id
        :choice-display-name-kw :name
        :label-transl-kw :page.project.list/status
        :placeholder-transl-kw :form.advanced-select/select}]
      [layout.form/item
       {:context view-context
        :type :checkbox
        :path [:requires-review :selected]
        :schema [:boolean]
        :state state
        :label-transl-kw :page.project.list/requires-review}]
      [layout.form/item
       {:context view-context
        :type :checkbox
        :path [:aged-gt-10-years :selected]
        :schema [:boolean]
        :state state
        :label-transl-kw :page.project.list/aged-gt-10-years}]]
     [tooltip.generic-popup/generic-popup-footer
      {:popup-id popup-id
       :on-cancel {:evt [::tooltip/destroy-by-id {:id popup-id}]}
       :on-accept {:label-transl-kw :common/apply
                   :fn (fn [] (form-submit state on-submit))}
       :extra-buttons [{:label-transl-kw :common/clear
                        :on-click {:fn (fn []
                                         (swap!
                                          state
                                          (fn [s]
                                            (-> s
                                                (assoc-in [:products :checked] {})
                                                (assoc-in [:statuses :checked] {})
                                                (assoc-in [:products :selected] #{})
                                                (assoc-in [:statuses :selected] #{})
                                                (assoc-in [:requires-review :selected] false)
                                                (assoc-in [:aged-gt-10-years :selected] false))))
                                         (form-submit state on-submit))}}]}]]))

(rf/reg-event-fx
 ::close
 (fn [_]
   {:fx [[:dispatch [::form.error/clear-errors view-context]]
         [:dispatch [::tooltip/destroy-by-id {:id popup-id}]]]}))

(rf/reg-event-fx
 ::open
 (fn [_ [_ opts]]
   {:fx [[:dispatch [::load-filters]]
         [:dispatch [::tooltip/register {:id popup-id
                                         :on-destroy-evt [::close]
                                         :component main
                                         :argv [opts]
                                         :class ["generic-popup-standard"]}]]]}))
